import axios from "axios";
import API_CONFIG from "../config/apiConfig";
import { AUTH_TOKEN_KEY } from "../config/authToken";
import { clearAuthAndRedirectToSignIn } from "../utils/authSession";

const httpClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: { "Content-Type": "application/json" },
});

function isCouponPublicDetailPath(path) {
  if (!path || path === "/coupons/all" || path === "/coupons/trending") return false;
  if (path.startsWith("/coupons/category/")) return false;
  return /^\/coupons\/[^/]+$/.test(path);
}

function shouldAttachVisitorCountry(url) {
  if (!url || typeof url !== "string") return false;
  const path = url.split("?")[0];
  return (
    path === "/coupons/all" ||
    path === "/coupons/trending" ||
    path.startsWith("/coupons/category/") ||
    isCouponPublicDetailPath(path) ||
    path === "/store/all" ||
    /^\/store\/slug\/[^/]+$/.test(path) ||
    /^\/store\/slug\/[^/]+\/coupons$/.test(path) ||
    path === "/search/suggestions"
  );
}

httpClient.interceptors.request.use((config) => {
  const token =
    typeof window !== "undefined" ? window.localStorage.getItem(AUTH_TOKEN_KEY) : null;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (
    typeof window !== "undefined" &&
    config.method?.toLowerCase() === "get" &&
    shouldAttachVisitorCountry(String(config.url || ""))
  ) {
    const params = config.params && typeof config.params === "object" ? { ...config.params } : {};
    if (params.country == null || params.country === "") {
      const code = window.localStorage.getItem("visitorCountryCode");
      if (code && /^[A-Z]{2}$/i.test(code.trim())) {
        params.country = code.trim().toUpperCase();
        config.params = params;
      }
    }
  }
  return config;
});

httpClient.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const url = String(error.config?.url || "");
    const isAuthAttempt =
      url.includes("/auth/login") ||
      url.includes("/auth/register") ||
      url.includes("/auth/forgot-password") ||
      url.includes("/auth/reset-password");
    if (status === 401 && !isAuthAttempt) {
      clearAuthAndRedirectToSignIn();
    }
    return Promise.reject(error);
  }
);

export default httpClient;
